/*
 * File: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice\src\Services\GroupService\GroupService.ts
 * Project: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice
 * Created Date: Tuesday July 4th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Monday, 3rd June 2024 10:38:02
 * Modified By: Simon (s.gourlet@autobuy.fr>)
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 */

import Config from "Config/Config";
import { buildAxiosHeader, buildURL } from "Utils/Request.utils";
import Axios, { AxiosResponse } from "axios";

class GroupService {
    static async createGroup(Name: string) {
        const myUrl = `${Config.BACKEND.BASEURL}${Config.BACKEND.PATHS.GROUPS}`;
        const myGroups = await Axios.post(myUrl, {Name}, buildAxiosHeader());
        return myGroups.data;
    }

    static async getAllGroups() {
        const myUrl = `${Config.BACKEND.BASEURL}${Config.BACKEND.PATHS.GROUPS}`;
        const myGroups = await Axios.get(myUrl, buildAxiosHeader());
        return myGroups.data;
    }

    static async getGroupsInfo() {
        const myUrl = `${Config.BACKEND.BASEURL}${Config.BACKEND.PATHS.GROUPINFO}`;
        const myRet = await Axios.get(myUrl, buildAxiosHeader());
        return myRet.data;
    }

    static async getUserGroups(id: string) {
        const myUrl = `${Config.BACKEND.BASEURL}${Config.BACKEND.PATHS.USERSGROUPS}/${id}?per_page=100000`;
        const myRet = await Axios.get(myUrl, buildAxiosHeader());
        return myRet.data;
    }

    static async manageUserGroup(toCreate: string[], toDelete: string[], groupID?: string, userID?: string) {
        const myUrl = `${Config.BACKEND.BASEURL}${Config.BACKEND.PATHS.GROUPSMANAGE}`;
        var myRet: AxiosResponse;
        if (userID) {
            let url = buildURL({fromUser: true}, myUrl)
            if (!url)
                throw new Error(`Unable to build URL from: ${Config.BACKEND.BASEURL}${Config.BACKEND.PATHS.GROUPSMANAGE} and ${JSON.stringify({fromUser: true})}`)
            myRet = await Axios.post(url, {toCreate, toDelete, userID}, buildAxiosHeader());
        }
        else
            myRet = await Axios.post(myUrl, {toCreate, toDelete, groupID}, buildAxiosHeader());
        return myRet;
    };
}

export default GroupService;
